<script setup>
import { computed } from 'vue';
import { concatName } from 'JIX/utils.js';
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/phone.svg';
import 'icons/contact-mail.svg';

const props = defineProps({
    user: {
        type: Object,
        required: true,
    },
});
const hasAnyInfo = computed(() => {
    return (props.user.profilePhoto && props.user.profilePhoto.url)
        || props.userFullname
        || props.user.email
        || props.user.cellphone
        || props.user.address_object?.simple_string;
});
const userFullname = computed(() => {
    return concatName(props.user);
});

</script>

<template>
    <div class="user-profile-info-print" v-if="hasAnyInfo">
        <img
            v-if="user.profilePhoto.url"
            :src="user.profilePhoto.url"
            :alt="userFullname"
            class="avatar avatar--md mr-3"
        >
        <div class="d-flex gap-4">
            <strong v-if="userFullname">{{ userFullname }}</strong>
            <div class="user-profile-info-print__item" v-if="user.address_object?.simple_string">
                {{ user.address_object.simple_string }}
            </div>
            <div class="user-profile-info-print__item flex-shrink-0" v-if="user.email">
                <SvgIcon size="xs" name="contact-mail" />
                {{ user.email }}
            </div>
            <div class="user-profile-info-print__item flex-shrink-0" v-if="user.cellphone">
                <SvgIcon size="xs" name="phone" />
                {{ user.cellphone }}
            </div>
        </div>
    </div>
</template>
